import React from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';

// *** simple message board
/**
 * 
 * @param {object} props
 * @param {string} props.title
 * @param {string} props.version
 * @param {string} props.subTitle 
 */
const MessageBoard = (props) => {
  return (
    <div css={css`
      width: 100%;
      padding: 10px 0;
      font-size: 1.1rem;
      font-weight: 500;
      div{
        text-align: center;
      }
    `}>
        <div>{`${props.messageBoardItems.title}`}</div>
        <div>{`${props.messageBoardItems.version}`}</div>
        <div>{`${props.messageBoardItems.subTitle}`}</div>
    </div>
  )
}

export default MessageBoard;

MessageBoard.defaultProps = {
  title: "",
  version: "",
  subTitle: ""
}